import {
  LevelEnumType,
  SsStandardsAggregationTypeEnum,
} from '@lon/shared/requests';

export const isValidEnumKey = (
  key: string | undefined = ''
): key is keyof typeof LevelEnumType => {
  return key in LevelEnumType;
};

export const isValidAggrigateKey = (
  key: string | undefined = ''
): key is keyof typeof SsStandardsAggregationTypeEnum => {
  return key in SsStandardsAggregationTypeEnum;
};
